import { combineReducers } from 'redux'
import { ABOUT_US } from '../../common/constants/actionConstants'


const currentInerventionList = (state = [], action) => {
    switch (action.type) {
   
      case ABOUT_US:
        return { ...action.payload }
      default:
        return state
    }
  }

  const AboutUsReducer = combineReducers({
    currentInerventionList
  })
  
  export default AboutUsReducer
  